module.exports = __webpack_public_path__ + "img/yiyao_fufeng_suoluetu.e73a5f3b.png";